import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { BoxMovementSummary } from "../../transfers.types";
import { requestGetBoxMovementSummary } from "./getBoxMovementSummary.request";

const useGetBoxMovementSummary = (
  options?: QueryOptions<BoxMovementSummary, ApiServiceError<ApiError>>,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["box-movement-admin", "summary"],
    queryFn: async () => await requestGetBoxMovementSummary(),
    ...options,
  });

  return { summary: data, ...rest };
};

export default useGetBoxMovementSummary;
